module.exports = __webpack_public_path__ + "media/images/icon-magnifier-6db75ecb952c3c7a5253025b42048489.svg";